import { AppThunk } from '../../../store/rootReducer';
import { getBaseProperties, track } from '../analytics.utils';
import {
  ADD_DIAGNOSTIC_LABEL,
  DELETE_DIAGNOSTIC_LABEL,
} from '../analytics.constants';

export const trackDiagnosticLabel =
  (
    name: typeof DELETE_DIAGNOSTIC_LABEL | typeof ADD_DIAGNOSTIC_LABEL,
    value: string,
    analyticsTrack = track,
  ): AppThunk =>
  (_, getState) => {
    const baseProperties = getBaseProperties(getState);
    if (baseProperties == null) {
      return null;
    }
    const { ecgId, userId, view } = baseProperties;

    analyticsTrack({
      name,
      properties: {
        view,
        ecg_id: ecgId,
        user_id: userId,
        value,
      },
    });
  };
